"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var vatRules = [{
  countryCode: "IT",
  types: ["private"]
}];
var _default = vatRules;
exports.default = _default;